import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";

/**
 * selectPreferredAddress selects the priority address from a member's address list returned
 * from the identity service. This address will be used for EDD/BOPIS determination.
 *
 * @returns {object} member address data meant for EDD/BOPIS values
 */
export var selectPreferredAddress = function selectPreferredAddress(addresses) {
  var _getWebShellClientLoc;
  if (!addresses || !Array.isArray(addresses) || (addresses === null || addresses === void 0 ? void 0 : addresses.length) === 0) {
    return {};
  }
  var localeCountry = (_getWebShellClientLoc = getWebShellClientLocale().country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase();
  var addressesInCountry = addresses.filter(function (address) {
    return (address === null || address === void 0 ? void 0 : address.country) === localeCountry;
  });
  var preferredAddressInCountry = (addressesInCountry === null || addressesInCountry === void 0 ? void 0 : addressesInCountry.filter(function (addr) {
    return (addr === null || addr === void 0 ? void 0 : addr.preferred) || (addr === null || addr === void 0 ? void 0 : addr.label) === 'shipping';
  })[0]) || (addressesInCountry === null || addressesInCountry === void 0 ? void 0 : addressesInCountry[0]);
  return preferredAddressInCountry !== null && preferredAddressInCountry !== void 0 ? preferredAddressInCountry : {};
};